var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10283a;}.cls-2{fill:#173856;}.cls-3{fill:#fbbcaa;}.cls-4{fill:#20456e;}.cls-5{fill:#00a891;}.cls-6{fill:#442114;}.cls-7{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bas frame 4 m") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bas_m_4",
    "data-name": "bas m 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.41,1408v70c0,26.91-67,26.91-67,0v-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1007.41,1248l12,289c.18,3.41,78.18-.59,78-4V1252Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M916.41,1252l7,185c0,34.27,80,34.27,80,0l10-99-5.75-86Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1137.44,1192.8c-5.12-18.42-62.12-6.06-57,12.37,0,0,3,33.56,37,28.26S1137.44,1192.8,1137.44,1192.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1081.41,1019.54c22.59.39,40.5,9.34,49,35.46l12,135c0,36-58,40-58,13Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1097.59,1252.5v-203s0-50-90.59-50-90.59,40-90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 916.41,
    y: 1244,
    width: 181,
    height: 9,
    transform: "translate(1496.82 1886) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1010.41,1033c22.07-3.49,40.42-10.38,50-25.29-4.28-6.19-9.41-11.82-25-10.6l-15-.11-4.51,2.79C1057.47,1008.23,1034.81,1020.56,1010.41,1033Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1002.41,1032.89c-22.07-3.49-40.42-10.39-50-25.29,4.29-6.19,9.41-11.83,25-10.6l15-.11,4.51,2.79C955.36,1008.12,978,1020.45,1002.41,1032.89Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M815,836.19c14-20.19,23.41-3.79,23.41-5.69a169,169,0,0,1,168.59-169h.41A169,169,0,0,1,1176,830.5c0,1.9,9.41-14.5,23.41,5.69,7.72,11.13,8.89,57.77-9,76.81-14.55,15.49-33,24-45.38,15a168.78,168.78,0,0,1-137.62,71.45H1007A168.78,168.78,0,0,1,869.38,928c-12.38,9-30.83.45-45.38-15C806.11,894,807.28,847.32,815,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M931.44,1016.54c-22.58.39-40.49,9.34-49,35.46l-28,148c14,24,49,33,62,18Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M863.66,1209c1.24-8.77,45.49,3.82,44.82,11,0,0-2.36,29.89-29.09,25.17S863.66,1209,863.66,1209Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M825.57,788C838.87,685.67,927.65,645.22,1008,647.4c80.39-2.18,169.17,38.27,182.47,140.6,1.91,42-5.09,39-15.09,42-6,13-15,13-20,10-.63-11.94-.32-22.08-5-41-7.45-3.34-18.27-11.35-24-19-4.29-5.52-11.11-29.76-21-32-37.8-8.57-82.42-10.92-97-10.88h-.75c-14.58,0-59.2,2.31-97,10.88-9.89,2.24-16.71,26.48-21,32-5.73,7.65-16.55,15.66-24,19-4.68,18.92-4.37,29.06-5,41-5,3-14,3-20-10C830.66,827,823.66,830,825.57,788Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1093.41,1540v33h-67v-34C1028.11,1510.55,1095.11,1511.55,1093.41,1540Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomFrame4);
export default __webpack_public_path__ + "static/media/bottom_frame_4.bc1b0449d1ae55d5f271485f6cfbb309.svg";
export { ForwardRef as ReactComponent };